/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aigenerate1Inputs */

const en_aigenerate1 = /** @type {(inputs: Aigenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate`)
};

const de_aigenerate1 = /** @type {(inputs: Aigenerate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generieren`)
};

/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Aigenerate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aigenerate1 = /** @type {((inputs?: Aigenerate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aigenerate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aigenerate1(inputs)
	return de_aigenerate1(inputs)
});
export { aigenerate1 as "aiGenerate" }